import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const DisableWaitlistCheckbox = ({ input: { onChange, value }, label, disabled }) => (
  <FormControlLabel
    control={
      <Checkbox
        disabled={disabled}
        color="primary"
        checked={typeof value === 'number'}
        onChange={(_, newValue) => onChange(newValue ? 0 : null)}
      />
    }
    label={label}
  />
);
